function ConsultantInvoicesCards({
  Arr_Invoices,
  obj_EC,
  Arr_ECs,
  screenWidth,
  getAttendeeNames,
}) {
  return (
    <div
      class="w3-row-padding w3-center w3-padding-64 w3-theme-l5"
      id="pricing"
    >
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        {Arr_Invoices.map((obj_invoice, index) => (
          <div
            class="w3-third w3-margin-bottom"
            style={{
              width: screenWidth === "Small" ? "100%" : "",
            }}
          >
            <ul class="w3-ul w3-border w3-hover-shadow">
              <li class="w3-theme">
                <p class="w3-large">
                  {obj_invoice.Invoice_Number || ""},{" "}
                  {getAttendeeNames(obj_invoice) || ""}
                </p>
              </li>
              <li class="w3-padding-16">
                {obj_invoice.DateTime
                  ? "Create Date: " +
                    obj_invoice.DateTime.substring(8, 10) +
                    "/" +
                    obj_invoice.DateTime.substring(5, 7) +
                    "/" +
                    obj_invoice.DateTime.substring(2, 4)
                  : ""}
              </li>
              <li class="w3-padding-8">
                {obj_invoice.Due_Date
                  ? " Due: " +
                    obj_invoice.Due_Date.substring(8, 10) +
                    "/" +
                    obj_invoice.Due_Date.substring(5, 7) +
                    "/" +
                    obj_invoice.Due_Date.substring(2, 4)
                  : ""}
              </li>
              <li class="w3-padding-8">
                {obj_invoice.Amount ? "Amount: £" + obj_invoice.Amount : ""}
              </li>
              <li class="w3-padding-8">
                {obj_invoice.Paid_Date ? (
                  "Paid Date: " +
                  obj_invoice.Paid_Date.substring(8, 10) +
                  "/" +
                  obj_invoice.Paid_Date.substring(5, 7) +
                  "/" +
                  obj_invoice.Paid_Date.substring(2, 4)
                ) : (
                  <></>
                )}
              </li>
              <li class="w3-padding-8">
                {obj_invoice.Paid_Status === "Paid" ? (
                  <p
                    style={{
                      backgroundColor: "rgba(6, 134, 47, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Paid
                  </p>
                ) : (
                  <p
                    style={{
                      backgroundColor: "rgba(8, 83, 182, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    UnPaid
                  </p>
                )}
              </li>
              <li class="w3-padding-8">
                {obj_invoice.Paid_Status === "Paid" ? (
                  <p></p>
                ) : obj_invoice.Link && obj_invoice.Link.length > 0 ? (
                  <p>
                    <button
                      onClick={() => window.open(obj_invoice.Link, "_blank")}
                    >
                      Payment Link
                    </button>
                  </p>
                ) : (
                  <></>
                )}
              </li>
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConsultantInvoicesCards;
